import { useUI } from "providers/UIProvider"

import { Flex } from "@chakra-ui/react"
import { IStatusButtonProps } from "./StatusButtonTypes"

const StatusButton:React.FC<IStatusButtonProps> = ({isNew, isOpen, hasChanges}) => {

    const { T } = useUI()
    
    const generateStatusData = () =>{
        if(hasChanges) {
            return {
                color: "#F30028",
                status: T("laundries.table.columns.status.pending")
            }
        }

        if(!hasChanges && isNew) {
            return {
                color: "#046CEC",
                status: T("laundries.table.columns.status.new")
            }
        }

        if(!hasChanges && isOpen) {
            return {
                color: "#08BA36",
                status: T("laundries.table.columns.status.open")
            }  
        }

        return {
            color: "#F30028",
            status: T("laundries.table.columns.status.closed")
        }
    }

    const statusData = generateStatusData()
  
    return(
      <Flex color={"white"} alignItems={"center"} justifyContent="center" background={statusData.color} borderRadius="4px" >
            {statusData.status}
      </Flex>
    )
}
export default StatusButton 